import { Draft } from '@/types';
import { round } from '@/utils/math/round';
import { getProductType } from '@/model/draft/getProductType';
import { getPrintAreaPrices } from '@/model/pricing/getPrintAreaPrices';
import { getProductTypePrice } from '@/model/pricing/getProductTypePrice';
import { totalPrice } from '@/model/pricing/totalPrice';
import { getPriceStrategy } from '@/redux/core/getters/getPriceStrategy';
import { StoreState } from '@/redux/types';

export function getPriceBreakdown(draft: Draft, state: StoreState): PriceBreakdown {
  const priceStrategy = getPriceStrategy(state);

  const productType = getProductType(draft);
  const ptPrice = getProductTypePrice(state, productType);

  const areas = getPrintAreaPrices(priceStrategy, draft, state);
  const productPrice = round(totalPrice(ptPrice, areas), 2);

  return {
    productType: ptPrice,
    areas,
    product: productPrice,
    priceStrategyType: priceStrategy.type,
  };
}
